import { oneApi } from 'config/api'
export default {
  mounted() {
    const externalUserId = window.sessionStorage.getItem('external_user_id')
    const id = window.sessionStorage.getItem('courses_detail_id')
    if (externalUserId && id && (id === this.$route.params.coursesId)) {
      const params = {
        externalUserId,
        productId: Number(id),
        productType: 4
      }
      if (window.sessionStorage.getItem('source_id')) {
        params.sourceId = window.sessionStorage.getItem('source_id')
      }
      this.$axios.post(oneApi.recordQwLink, params, { rewritePostBody: true, corpId: window.sessionStorage.getItem('corp_id') || '' }).then((res) => {
        if (Number(res.code) === 0) {
          console.log('记录浏览记录成功', res);
        }
      })
    }
  }
}
